import { MapperBase } from '../../utilities/mapper-base';
import { FileType } from '../ui/file.model';
import { FileTypeResource } from '../resource/file-type.resource';
import { FileTypeToFileTypeResourceMap } from './maps/file-type-to-file-type-resource.map';

export class FileTypeToFileTypeResourceMapper extends MapperBase<FileType, FileTypeResource> {
	map(source: FileType): FileTypeResource {
		return FileTypeToFileTypeResourceMap.get(source);
	}
}

